module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAAXNSR0IArs4c6QAAAH9JREFUKFOl0TsKgDAQBNBZ8JQWWpgql1AvoRZaJKCnFFZWMPjJhoBpZ+cVGULilbVtJN7csGhnpAVlZVsidJIzo9v80Mduo8C9fJU05APEyinkAaTKGhKAnHIMOQH5bQLm1CLvjAEj6wQAjIkIRQ7CjJ3AZvWjU2fMgeTmN3AAiwA3C+kZ6DgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/img(11).png
// module id = n1I0
// module chunks = 1